import { render, staticRenderFns } from "./SelectUI.vue?vue&type=template&id=5fdc4a11&scoped=true&"
import script from "./SelectUI.vue?vue&type=script&lang=js&"
export * from "./SelectUI.vue?vue&type=script&lang=js&"
import style0 from "./SelectUI.vue?vue&type=style&index=0&id=5fdc4a11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdc4a11",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
